<template >
	<div class="TableView" ref="topel" >
		
		<div class="search_holder" v-if="show_search">
			<form @submit.prevent="runSearch()" class="search_form">
				<input type="text" class="normal_input" ref="searchinput" placeholder="Search" v-model="search_input" />
				<button class="clearsearch" tabindex="-1" title="Clear Search" type="button" @click.prevent="clearSearch" v-if="search_input" >&times;</button>
				<button class="searchbutton btn-outline" >Go</button>
			</form>
			<div class="filters" v-if="!hide_filters">
				<div class="filter" v-for="filter in filters" :key="filter.key" >
					<template v-if="filter.label">
						<b>{{ filter.label }}</b>
					</template>
					<template v-else >
						<b>{{ filter.key }}:</b> {{ filter.val }}
					</template>

					<i class="fa fa-lock"></i>
				</div>
			</div>
		</div>

		<div class="table_holder">
			<div class="table">
				
				<div class="row heading">
					<div class="cell status" v-if="rowstatus !== undefined" ></div>
					<div 
						v-for="(col,k) in cols" 
						:key="col.label"  
						:class="{cell:1,sort_col:k==sort_col,can_sort:col.sort_code}"
						:style="cellStyle(-1,k)"
					>
						{{ col.label }}
						
						<button v-if="col.sort_code" @click.stop.prevent="sortButtonClick(k)" tabindex="-1" >
							<i v-if="sort_col==k&&!sort_desc" class="fa fa-caret-up"></i>
							<i v-else class="fa fa-caret-down"></i>
						</button>
					</div>
				</div>

				<div v-if="errored" class="row errored" >
					<div class="cell">Error loading results</div>
				</div>

				<div v-else-if="items!==null&&items.length==0" class="row empty" >
					<div class="">No results found</div>
				</div>

				<div v-else 
					v-for="(row,rk) in rows" :key="row.id" 
					:class="{
						row:1,
						loading:loading&&!appending,
						appending,
						clickable:rowIsClickable(row)
					}" 
				>
					<div v-if="row.status !== undefined" class="cell status" >
						<span :class="['statusball','c-bg-'+row.status]"></span>
					</div>

					<!-- AVAILABLE CELL -->
					<div v-for="(item,k) in row.items" :key="k" :class="cellClass(k,item,row)" :style="cellStyle(rk,k)" :data-infopopup="item ? item.TEMP_INFO_POPUP : ''"  :title="item ? item.title : ''" >

						<!-- UNDEFINED -->
						<template v-if="item === undefined" >
							⚠ undefined
						</template>

						<!-- EMPTY -->
						<template v-else-if="item === null" >
							-
						</template>

						<!-- SPECIAL -->
						<template v-else-if="typeof item === 'object'" >
							
							<!-- STATUS -->
							<!-- <span v-if="item.status !== undefined" :class="['statusball','status-'+item.status]"></span> -->

							<!-- LOADING -->
							<span v-if="item.loading" class="loading_string"></span>
							
							<!-- HTML -->
							<span v-else-if="item.html" v-html="item.html" ></span>
							
							<!-- LINK -->
							<router-link v-else-if="item.to" :to="item.to" :class="{rowlink:isRowLink(row,item)}"  >{{ item.format ? applyFormat(item.value,item.format) : item.value }}</router-link>

							<!-- HREF -->
							<a v-else-if="item.href" :href="item.href" :class="{rowlink:isRowLink(row,item)}"  >{{ item.value === null ? 'View' : item.value }}</a>
							
							<!-- FORMATTED TEXT -->
							<template v-else-if="item.format" >
								{{ applyFormat(item.value,item.format) }}
							</template>

							<!-- ACTIONS -->
							<template v-else-if="item.buttons" >
								<button v-for="(button,k) in item.buttons" :key="k" @click.prevent.stop="button.click" >
									{{ button.label }}
								</button>
							</template>

							<template v-else-if="item.status" >
                                <span :class="['status-tag','status-'+item.status]">
								    {{ item.value }}
                                </span>
							</template>

							<!-- NORMAL VALUE -->
							<template v-else-if="item.value !== null" >
								{{ item.value }}
							</template>

							<ul v-if="item.tags" class="tags" >
								<li v-for="(li,ik) in item.tags" :key="ik" :style="calculateTagStyle(li)" >{{ typeof item === 'object' ? li.label : li }}</li>
							</ul>
							<ul v-if="item.list" >
								<li v-for="(li,ik) in item.list" :key="ik">{{ li }}</li>
							</ul>

                            <div v-if="item.subtext" class="subtext" >{{ item.subtext }}</div>
                        
						</template>

						<template v-else >
							{{ item }}
						</template>
					</div>
				</div>
				<template v-if="items!==null&&canAppend()" >
					<div v-for="r in 5" :key="'more'+r" class="row" >
						<div v-for="c in n_columns" :key="c" :style="cellStyle(r,c-1)" :class="{cell:1,sort_col:c==sort_col}" >
							<span class="loading_string"></span>
						</div>
					</div>
				</template>
				<template v-if="!errored&&(appending||(loading&&items===null))" >
					<div v-for="r in 5" :key="'loading'+r"  class="row" >
						<div v-for="c in n_columns" :key="c" :style="cellStyle(r,c-1)" :class="{cell:1,sort_col:c==sort_col}" >
							<span class="loading_string"></span>
						</div>
					</div>
				</template>

			</div>
		</div>


		<div v-if="paginate && !hide_pagination" class="pagination_holder">
			Page {{ page }} of {{ n_pages }}
			<span class="split"></span>
			<button :disabled="page<=1" type="button" @click="changePage(page-1)" class="btn btn-b">&lsaquo;</button>
			<button :disabled="page>=n_pages" type="button" @click="changePage(page+1)" class="btn btn-b">&rsaquo;</button>
			<span class="split"></span>
			<button v-for="n in n_pages" :key="n" type="button" @click="changePage(n)" :class="{'btn':1,'btn-outline':1}" :disabled="n==page">{{n}}</button>

		</div>
	</div>
</template>


<script>

	import { ref } from "vue";

	var moment = require('moment');
	var _ = require('lodash');

	export default {
		props : [
			'cols',
			'rowdata',
			'rowstatus',
			
			'data_url',
			
			'data',
			'data_loading',
			
			'starting_filters',
			'settings',
		],				
		
		setup(props) {

			// Optional
			const rowstatus = ref(props.rowstatus);
			const filters = ref(props.starting_filters||[]);
			const settings = props.settings||{};


			// State
			const search_input = ref('');
			const current_search = ref('');
			const errored = ref(false);
			const loading = ref(props.data_loading || false);
			const appending = ref(false);
			const items = ref(props.data || null);
			const page = ref(1);
			const n_pages = ref(1);
			const n_results = ref(1);
			const ignore_row_click = ref(null);
			const resources = ref({});

			// Calculated
			let sort_col_indx = props.cols.findIndex(x=>x.default_sort);
			// if(sort_col_indx == -1) sort_col_indx = 0;
			const sort_col = ref(sort_col_indx);

			let sort_col_desc = sort_col_indx == -1 ? undefined : props.cols[sort_col_indx].sort_desc;
			if(sort_col_desc === undefined) sort_col_desc = true;
			const sort_desc = ref(sort_desc);

			return {
				
				filters,
				sort_col,
				sort_desc,

				search_input,
				current_search,

				// Settings
				paginate : ref(settings.paginate || false),
				hide_pagination : ref(settings.hide_pagination || false),
				hide_filters : ref(settings.hide_filters || true),
				show_search : ref(settings.show_search || false),
				page_size_override : ref(settings.page_size || false),

				// States 
				errored,
				loading,
				appending,
				items,
				page,
				n_pages,
				n_results,
				ignore_row_click,
				resources,

                cancel:null,
                CancelToken:axios.CancelToken
            };
		},

		mounted(){
			if(this.data_url){
				this.getData();
			}
			if(!this.paginate) window.addEventListener('scroll', this.createOnScroll() , true);
		},

		watch:{
			data(){
				this.items = this.data;
			},
			data_loading(){
				this.loading = this.data_loading;
			},
		},
		
		unmounted() {
			if(!this.paginate) window.removeEventListener('scroll', this.createOnScroll() , true);
		},
		
		computed:{
			n_columns(){
				var n = this.cols.length;
				if(this.rowstatus !== undefined) n++;
				return n;
			},
			row_widths(){
				let total_width_weights = this.cols.reduce((a,c)=>a+(c.width_weight||1),0);
                // if(this.onSelection) total_width_weights += 0.1;//%
                if(this.rowstatus) total_width_weights += 0.1;//%
				return this.cols.map((x)=> (x.width_weight||1)/total_width_weights*100 );
			},
			sort_code(){
				return this.sort_col == -1 ? null : this.cols[this.sort_col].sort_code;
			},
			rows(){
				var self = this;
				return (this.items||[]).map((item,i)=>{
					var row = {
						id : item.id || i,
						items:self.cols.map(col=>col.render(item)).map(self.expandResourceData),
					}
					if(self.rowstatus){
						row.status = self.rowstatus(item);
					}
					return row
				});
			},
			sorted_rows(){
				return this.rows;
			}
		},
		methods: {

			reload(){
				this.getData();
			},


			clearSearch(){
				this.search_input = '';
				if(this.current_search != ''){
					this.current_search = '';
					this.page = 1;
					this.getData();
				}
				this.$refs.searchinput.focus();
			},

			cellStyle(row_index,cell_index){
				return {'flex':'0 0 '+this.row_widths[cell_index]+'%'};
			},
					
			createOnScroll(){
				var self = this;
				return _.debounce(() => {
					self.appendNextPageIfNeeded();
			   }, 50);
			},
					
			calculateTagStyle(list_item){
                let color = null;
                let bgcolor = null;
                let hashtext = list_item;
                
                if(typeof list_item === 'object'){
                    color = list_item.color||null;
                    bgcolor = list_item.backgroundColor||null;
                    hashtext = list_item.label;
                }

                if(!bgcolor){
                    const generateNumericHash = (s)=>{ 
                        var h = 0, l = s.length, i = 0; 
                        if( l > 0 ) while(i < l) h = (h << 5) - h + s.charCodeAt(i++) | 0;
                        return h;
                    }
                    const hue = (Math.round(parseInt(generateNumericHash(hashtext))* 3.14) + 90) %360;
                    bgcolor = 'hsl( ' + hue + ' , 60%, 90%)' ;
                }

				return {
					background: bgcolor,
                    color
				};
			},
			
			getData( append ){
				var self = this;

                if(!append && self.loading && this.cancel){
                    this.cancel('ABORT');
                }

                if(!append){
                    this.items = null;
                }

				self.loading = true;
				self.appending = append;

				let params = {};
				if(this.current_search.trim()) params.search = this.current_search;
				if(this.sort_code !== null) params.order_col = this.sort_code;
				if(this.sort_desc !== null) params.order_desc = this.sort_desc;
				if(this.page) params.page = this.page;
				if(this.page_size_override) params.page_size = this.page_size_override;

				this.filters.map( f =>{
					if(f.key && f.val) params[f.key] = f.val;
				});

				return axios.get(this.data_url,{
                    params,
                    cancelToken: new this.CancelToken((c)=>{
                                    this.cancel = c;
                                }),
                }).then(({data})=>{
					self.errored = false;
					self.items = [
						...( append ? self.items : [] ),
						...(data.data||[])
					];
					self.n_results = (data.meta||{}).total;
					self.n_pages = (data.meta||{}).last_page;
					self.page = parseInt((data.meta||{}).current_page);
					self.processResources();
				}).catch((e)=>{
                    if( (e||{}).message != 'ABORT'){
                        self.errored = true;
                        console.error(e)
                    }
				}).finally(()=>{
                    self.loading = false;
					self.appending = false;
					self.appendNextPageIfNeeded();
				})
				
			},


			processResources(){
				var self = this;

				var lineresources = this.rows.reduce((a,row)=>{
					return [
						...a,
						...row.items.filter(rowcol=>{
							return !!rowcol && !!rowcol.resource;
						}).map(x=>x.resource)
					];
				},[]);
				
				var existing_resources = Object.keys(this.resources);
				
				var requests_to_make = lineresources.filter(x=>(x.id && x.name)).reduce((a,c)=>{
					var existing = a.findIndex(x=>x.name==c.name);
					if(existing == -1){
						a.push({ name: c.name , ids : [c.id]});
					} else {
						a[existing].ids.push(c.id);
					}
					return a;
				},[]);
				
				requests_to_make.map(request=>{
					// Register IDs and list new ones
					var ids = request.ids.filter(id=>{
						var rid = [request.name,id].join('/');
						if(self.resources[rid] === undefined){
							self.resources[rid] = null;
							return true;
						}
						return false;
					});

					if(ids.length){
						return axios.get('/'+request.name,{params:{ids:ids.join(',')}}).then(({data})=>{
							data.data.map(item=>{
								const rid = [request.name,item.id].join('/');
                                self.resources[rid] = item;
							})
						}).catch(()=>{
							alert('Failed to load some additional data for the table');
						}).finally(()=>{
							self.loading = false;
						})
					}
					
					return true;
				});
			},


			expandResourceData(col){
				if(col && col.resource){
					var res = col.resource;
					var rk = [res.name,res.id].join('/');
					if(!res.id){
						col.value = '-';
					} else if(this.resources[rk] === undefined){
						col.value = '...';
					} else if(this.resources[rk] === null) {
						col.loading = true;
					} else if(res.render) {
						return {
							...col,
							...res.render(this.resources[rk])
						};
					} else {
						col.value = 'NORENDER';
					}
				}
				return col;
			},


			sortButtonClick(col_index){
				if(this.sort_col == col_index){
					this.sort_desc = !this.sort_desc;
				} else {
					this.sort_col = col_index;
					this.sort_desc = true;
				}
				this.page = 1;
				this.getData();
			},

			calculateRowLink(row){
				return row.items.find( item => typeof item ==='object' && (item.to||item.href) );
			},

			rowIsClickable(row){
				return !!this.calculateRowLink(row);
			},

			isRowLink(row,item){
				return item == this.calculateRowLink(row);
			},

			cellClass(k,item,row){
				var c = {
					cell:1,
					sort_col:k==this.sort_col,
				};
				if(item && item.classes) c = {...c,...item.classes};
				if( item && item.TEMP_INFO_POPUP ) c['InfoPopup'] = 1;
				if(row && item && row.status && item.inherit_status_color) c['c-'+row.status] = 1;
				return c;
			},

			changePage(page){
				this.page = page;
				this.getData();
			},

			appendNextPageIfNeeded(){
				if(this.paginate) return ;

				var bounds = this.$el.getBoundingClientRect();
				var distance_to_bottom = bounds.bottom - window.innerHeight;
				if(distance_to_bottom < 300 && !this.loading) this.appendNextPage();
			},

			canAppend(){
				return !this.paginate && (this.page < this.n_pages) && !this.errored;
			},

			appendNextPage(){
				if(!this.canAppend()) return false;
				this.page = this.page+1;
				this.getData(true);
			},

			runSearch(){
                this.current_search = this.search_input;
				this.page = 1;
				this.getData();
			},

			applyFormat(str,format){
				switch(format){
					case 'date-short':
						return str ? moment.utc(str).format('DD/MM/YYYY') : '-'; 
					case 'date-relative':
                        return str ? moment.utc(str).fromNow() : '-';
                    case 'datetime':
                        return str ? moment.utc(str).format('DD/MM/YYYY, HH:mm:ss') : '-'; 
					case 'price':
						return str===null ? '-' : '£'+ (parseInt(str)/100).toFixed(2).toLocaleString();
					case 'bool':
						return str ? 'Yes' : 'No';
					default:
						return str;
				}
			},

		}
	}
</script>
<style lang="scss" scoped>

$external-border-radius : 8px;

.TableView{
	background:#FFF;
    border:1px solid #CCC;
    border-radius: $external-border-radius;
	
	.table_holder{
		overflow-x: auto;
		border-top-left-radius:$external-border-radius;
		border-top-right-radius:$external-border-radius;
		
		div.table{
			width:100%;

			.row{
				display:flex;
				position: relative;

				.cell{
					padding:12px;
				}

				&.heading{
					border-bottom:1px solid #AAA;
					background:#fafafa;
                    
					.cell{
						&.can_sort{
							position: relative;
							padding-right:50px;
			
							button{
								display: block;
								cursor:pointer;
								position: absolute;
								top:0;
								right:0;
								width:100%;
								bottom:0;
								left:0;
								background:none;
								padding:12px;
								text-align:right;
								opacity:0.5;
								&:hover{
									background:rgba(0,0,0,0.05);
									opacity: 1;
								}
							}
						}
						
						&.sort_col{
							// background:rgba(0,0,0,0.05);
							button{
								opacity: 1;
							}
						}
					}
				}
			}
			
			.cell{
				flex-grow: 0;
				flex-shrink: 0;
				overflow: hidden;
				text-overflow: ellipsis;
				
				&.sort_col{
					background:rgba(0,0,0,0.02);
				}

				a,
				button{
					position: relative;
					z-index:10;
				}
				
				a.rowlink{
					z-index:5;
					position:static;

					&::after{
						content:'';
						position: absolute;
						top:0;
						left:0;
						bottom:0;
						right:0;
					}
	
					&:focus{	
						&::after{
							box-shadow: inset 3px 0 0px #1683db;
							background:rgba(22, 131, 219, 0.05);
						}
					}
				}
				
				ul.tags{
					margin:0;
					padding:0;
					list-style:none;
					li{
						padding:0.3em 0.5em;
						display:inline-block;
						vertical-align:middle;
                        letter-spacing: 0.05rem;
						font-size:0.7em;
						margin:0.1em;
						border-radius:0.2em;
						background:rgba(0,0,0,0.1);
						text-transform:uppercase;
					}
				}

			}
			.row{

				&.clickable{
					&:hover{
						background:rgba(0,0,0,0.05);
					}
				}

				&.loading{
					opacity: 0.3;
				}
				&.empty,
				&.errored{
					display:block;
					color:#AAA;
					background:#fafafa;
					text-align:center;
					padding:20px;
                    border-bottom-left-radius:$external-border-radius;
                    border-bottom-right-radius:$external-border-radius
				}
				&.errored{
					td{
						color:#b71c1c;
						background:#ffefef;
					}
				}
				
			}
			.row + .row {
				border-top:1px solid #EEE;
			}
		}

	}
	
	.search_holder + .table_holder {
		border-top-left-radius:0;
		border-top-right-radius:0;
	}

	.search_holder,
	.pagination_holder{
		padding:12px;
		background:#fafafa;
	}

	.search_holder{
		border-top-left-radius:$external-border-radius;
		border-top-right-radius:$external-border-radius;
		border-bottom:1px solid #CCC;
		display:flex;
		justify-content: space-between;
		align-items: center;

		.search_form{
			flex-basis: 220px;
			display: flex;
			position: relative;
			
			$h:36px;
			$sw:50px;
			$cw:40px;

			input{
				border-radius: 1000px;
				line-height:$h;
				padding: 0 $sw+$cw 0 20px;
			}

			.clearsearch{
                background:none;
                border:none;
                padding:0;
                margin:0;

				position: absolute;
				right:$sw;
				top:1px;
				line-height:$h;
				width:$cw+1px;
				text-align:center;
				z-index: 3;
				color:#AAA;
				&:hover{
					color:#888;
				}
			}
			
			.searchbutton{
				position: absolute;
				border:0;
				right:1px;
				top:1px;
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				line-height:$h;
				padding:0;
				text-align:center;
				width:$sw;
                box-shadow: none !important;
			}
		}

		.filters{
			margin-left:10px;
			display:flex;

			.filter{
				padding:10px 20px;
				background:rgba(0,0,0,0.6);
				border-radius: 500px;
				color:#FFF;

				i{
					margin-left:5px;
					opacity: 0.5;
				}

				& + .filter{
					margin-left:5px;
				}
			}
		}

	}

	.pagination_holder{
		border-top:1px solid #CCC;
		border-bottom-left-radius:$external-border-radius;
		border-bottom-right-radius:$external-border-radius;

		.split{
			display:inline-block;
			height:2em;
			width:0px;
			border-left:1px solid #CCC;
			margin:0 1em;
			vertical-align: middle;
		}

		.btn{
			margin:0 0.1em;
		}
	}
}



.status-tag{
    line-height:1.2rem;
    margin:-0.1rem 0;
    display: inline-block;
    font-size:0.7em;
    background:#EEE;
    padding:0 0.5em;
    border-radius:0.3em;
    letter-spacing: 0.02em;

    &.status-green{
        background:rgb(193, 255, 193);
    }

    &.status-amber{
        background:rgb(255, 216, 143);
    }

    &.status-red{
        background:rgb(255, 167, 167);
    }
}

.subtext{
    font-size:0.8em;
    color:#777;
}
</style>